import { useState, useEffect, useRef } from "react";
import { getMediaFileName, getMediaDescription } from "../utils/mediaUtils";
import FullscreenViewer from "./MediaFullscreenViewer";
import { mediaShell } from "../../../styles/mediaShell";

function MediaSlide({ media }) {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [displayUrl, setDisplayUrl] = useState(null);
    const currentMediaId = useRef(null);

    const enterFullscreenAndShow = () => {
        if (media?.media_type === "image") {
            setIsFullscreen(true);
        }
    };

    // derivファイルの存在に基づいて表示URLを更新
    useEffect(() => {
        if (!media) {
            setDisplayUrl(null);
            currentMediaId.current = null;
            return;
        }

        // media.id、media.url、media.raw_urlのいずれかが変更された場合に更新
        const newUrl = media.url || media.raw_url;
        const shouldUpdate = media.id !== currentMediaId.current;

        if (shouldUpdate) {
            currentMediaId.current = media.id;
            setDisplayUrl(newUrl || null);
        }
    }, [media]);

    if (!media) return null;

    const name = getMediaFileName(media);
    const description = getMediaDescription(media);

    let mediaContent = null;
    switch (media.media_type) {
        case "image":
            mediaContent = (
                <div className={mediaShell.imageContainer}>
                    {displayUrl && (
                        <img
                            key={`${media.id}-${displayUrl}`}
                            src={displayUrl}
                            alt={name}
                            className={mediaShell.image}
                            onClick={enterFullscreenAndShow}
                        />
                    )}
                    <div className={mediaShell.fullscreenIcon} onClick={enterFullscreenAndShow}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" fill="currentColor" />
                        </svg>
                    </div>
                </div>
            );
            break;
        case "video":
            mediaContent = (
                <div className={mediaShell.videoContainer}>
                    {displayUrl && (
                        <video
                            key={`${media.id}-${displayUrl}`}
                            src={displayUrl}
                            controls
                            className={mediaShell.video}
                        />
                    )}
                </div>
            );
            break;
        case "audio":
            mediaContent = (
                <div className={mediaShell.audioContainer}>
                    {displayUrl && (
                        <audio
                            key={`${media.id}-${displayUrl}`}
                            src={displayUrl}
                            controls
                            className={mediaShell.audio}
                        />
                    )}
                </div>
            );
            break;
        default:
            return (
                <div className={mediaShell.fileContainer}>
                    <a href={media.url} target="_blank" rel="noopener noreferrer" className={mediaShell.fileLink}>
                        {name || "メディアを開く"}
                    </a>
                </div>
            );
    }

    return (
        <div className={mediaShell.slideContentWrapper}>
            <div className={mediaShell.mediaItem}>
                {mediaContent}
                <div className={mediaShell.slideCaption}>{name}</div>
                {description && (
                    <div className={mediaShell.slideDescSection}>
                        <div className={mediaShell.slideDescription}>{description}</div>
                    </div>
                )}
            </div>
            {isFullscreen && (
                <FullscreenViewer
                    media={media}
                    onClose={() => setIsFullscreen(false)}
                />
            )}
        </div>
    );
}

export default MediaSlide;
